import { render } from "./ArtTimeline.vue?vue&type=template&id=533b0f74&scoped=true"
import script from "./ArtTimeline.vue?vue&type=script&lang=js"
export * from "./ArtTimeline.vue?vue&type=script&lang=js"

import "./ArtTimeline.vue?vue&type=style&index=0&id=533b0f74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533b0f74"]])

export default __exports__